/**
 * This is table-body script.js file
 */

import VTableCell from '@/components/table-cell/index.vue';

export default {
    name       : 'VTableBody',
    components : {
        VTableCell
    },
    props : {
        items : {
            type     : Array,
            required : true
        },
        columns : {
            type     : Array,
            required : true
        },
        widths : {
            type     : Object,
            required : true
        },
        self: {
            type: Array,
            required: true
        },
        section: {
            type: String,
            required: true
        },
        selectAll: {
            type: Boolean
        },
        isSearching: {
            type: Boolean,
            default: false
        }
    },
    /**
     * @override
     */
    data() {
        return {
            selectedItems: []
        };
    },
    watch: {
        /**
         * @override
         */
        selectAll(val) {
            this.selectedItems = [];
            if (val) {
                this.items.forEach(el => {
                    this.selectedItems.push(el);
                });
            }
        },
        items() {
            if (this.selectAll) {
                this.selectedItems = [];
                this.items.forEach(el => {
                    this.selectedItems.push(el);
                });
                this.$emit('row-selected', this.selectedItems);
            }
        }
    },
    methods: {
        /**
         * Añadimos el elemento clickado al array de seleccionados
         * @param {Object} item Elemento seleccionado
         */
        select(item) {
            const index =  this.selectedItems.indexOf(item);
            if (index < 0) {
                this.selectedItems.push(item);
            } else {
                this.selectedItems.splice(index, 1);
            }
            this.$emit('row-selected', this.selectedItems);
        },
        /**
         * @override
         */
        isSelected(id) {
            return this.selectedItems.find(x =>  x === id );
        },
        /**
         * Set selected rows
         * @param {Array} selectedItems New selected items
         */
        setSelectedItems(selectedItems) {
            this.selectedItems = selectedItems;
        }
    },
    computed: {
        /**
         * @override
         */
        selectAllItems() {
            return this.selectAll;
        },
        /**
         * @override
         */
        totalWidth() {
            let total = 50;
            this.columns.forEach(x => {
                total = total + this.widths[x.field];
            });
            // Se suma el tamaño del slot
            total += 42;
            return `${total}px`;
        }
    }
};
